import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppointmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Appointment",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M26.12 16.69c-2.98 0-4.41 3.26-4.41 3.26s-1.42-3.26-4.41-3.26-4 2.92-4 4.41c0 2.98 2.85 7.12 8.41 9.9 5.56-2.78 8.41-6.92 8.41-9.9 0-1.5-1.02-4.41-4.01-4.41Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.37 23.22H5c-.36 0-.65-.29-.65-.65V7.34c0-.31.25-.56.56-.56h1.65v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h7.94v1.84c0 .68.55 1.24 1.24 1.24s1.24-.55 1.24-1.24V6.78h1.56c.36 0 .65.29.65.65v7.2c0 .32.26.57.57.57h1.33c.32 0 .57-.26.57-.57V6.49c0-1.2-.98-2.18-2.18-2.18h-2.51V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08H9.03V2.23c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24 1.24v2.08h-2.5c-1.21 0-2.19.98-2.19 2.18V23.5c0 1.21.98 2.19 2.19 2.19h7.31c.25 0 .45-.2.45-.45v-1.57c0-.25-.2-.45-.45-.45Z"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.54",
      height: "3.54",
      x: "6.13",
      y: "11.67",
      rx: ".9",
      ry: ".9"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.54",
      height: "3.54",
      x: "6.13",
      y: "16.33",
      rx: ".9",
      ry: ".9"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.54",
      height: "3.54",
      x: "11.18",
      y: "11.67",
      rx: ".9",
      ry: ".9"
    }), /*#__PURE__*/_jsx("rect", {
      width: "3.54",
      height: "3.54",
      x: "16.23",
      y: "11.67",
      rx: ".9",
      ry: ".9"
    })]
  }));
};